/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestStepBaseAsJSON } from './AutoTestStepBaseAsJSON';
const AnyAutoTestStepAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['description', /* #__PURE__ */ parsers.maybeNull(codecString)],
]), AutoTestStepBaseAsJSON);
export class AnyAutoTestStepAsJSON extends AutoTestStepBaseAsJSON {
    static decode(input) {
        return AnyAutoTestStepAsJSONParser.decode(input).map(res => new AnyAutoTestStepAsJSON(res));
    }
    static unsafeDecode(input) {
        return AnyAutoTestStepAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return AnyAutoTestStepAsJSONParser.encode(data);
    }
    static schema() {
        return AnyAutoTestStepAsJSONParser.schema();
    }
}
